import {Injectable} from "@angular/core";
import {DialogService} from "~/app/core/dialog.service";
import {BehaviorSubject} from "rxjs";

@Injectable()
export class InstallService {
  private _ios: boolean = false;
  private _deferredPrompt: any;
  private _canInstall: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly dialogs: DialogService
  ) {
    // nothing
    this.init();
  }

  private init() {
    // Detects if device is on iOS
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test( userAgent );
    }

    // Detects if device is in standalone mode
    const isInStandaloneMode = () => ('standalone' in window.navigator) && ((window.navigator as any).standalone);

    this._ios = isIos();

    // Checks if should display install popup notification:
    if (this._ios && !isInStandaloneMode()) {
      this._canInstall.next(true);
    }
  }

  initInstall(event) {
    // console.log("onbeforeinstallprompt");
    // console.log(event);
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    event.preventDefault();
    // Stash the event so it can be triggered later.
    this._deferredPrompt = event;
    this._canInstall.next(true);
  }

  canInstall(): BehaviorSubject<boolean> {
    return this._canInstall;
  }

  addToHomeScreen() {
    if (this._ios) {
      this.dialogs.message({
        title: "Install App",
        message: "To install this webapp on your device, open this site in Safari, tap the SHARE icon, and then use the ADD TO HOME SCREEN option."
      });
    } else {
      // Show the prompt
      this._deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      this._deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            // console.log('User accepted the A2HS prompt');
            this._canInstall.next(false);
          } else {
            // console.log('User dismissed the A2HS prompt');
            this._canInstall.next(true);
          }
          this._deferredPrompt = null;
        });
    }
  }
}
